import { render, staticRenderFns } from "./ed-homework-file-object.vue?vue&type=template&id=77a46316&scoped=true&"
import script from "./ed-homework-file-object.ts?vue&type=script&lang=ts&"
export * from "./ed-homework-file-object.ts?vue&type=script&lang=ts&"
import style0 from "./ed-homework-file-object.scss?vue&type=style&index=0&id=77a46316&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a46316",
  null
  
)

export default component.exports